function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.36,86.75S70.52,137.64,47.54,200.51,42.25,334,95.42,377.93s132.09,19.64,206.42,38.69S449,412.8,465.91,334.93s-36.63-94.08-62.13-174.5S280.19-24.69,132.36,86.75Z",
    style: {
      fill: "#007CB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.36,86.75S70.52,137.64,47.54,200.51,42.25,334,95.42,377.93s132.09,19.64,206.42,38.69S449,412.8,465.91,334.93s-36.63-94.08-62.13-174.5S280.19-24.69,132.36,86.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 49.92,
    y1: 425.46,
    x2: 462,
    y2: 425.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.4,
    y1: 425.46,
    x2: 38.85,
    y2: 425.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.33,
    y: 99.81,
    width: 54.96,
    height: 34.57,
    rx: 1.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.33,
    y: 120.2,
    width: 54.96,
    height: 7.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.65,
    cy: 106.46,
    r: 3.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.89,
    cy: 106.46,
    r: 3.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.21,
    y1: 105.35,
    x2: 193.28,
    y2: 105.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 254,
    width: 54.96,
    height: 34.57,
    rx: 1.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 274.39,
    width: 54.96,
    height: 7.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,260.65a3.77,3.77,0,1,1-3.77-3.77A3.77,3.77,0,0,1,106.78,260.65Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.25,
    cy: 260.65,
    r: 3.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.57,
    y1: 259.54,
    x2: 76.64,
    y2: 259.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.56,
    y: 66.56,
    width: 34.15,
    height: 34.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.19 81.01 385.48 81.01 385.48 72.31 381.79 72.31 381.79 81.01 373.09 81.01 373.09 84.7 381.79 84.7 381.79 93.41 385.48 93.41 385.48 84.7 394.19 84.7 394.19 81.01",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.64,
    y: 66.56,
    width: 34.15,
    height: 34.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.61,
    y: 81.01,
    width: 18.19,
    height: 3.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.56,
    y: 100.65,
    width: 34.15,
    height: 34.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.79 108.18 383.64 114.33 377.49 108.18 374.88 110.79 381.03 116.94 374.88 123.09 377.49 125.7 383.64 119.55 389.79 125.7 392.4 123.09 386.25 116.94 392.4 110.79 389.79 108.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.64,
    y: 100.65,
    width: 34.15,
    height: 34.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.61,
    y: 115.09,
    width: 18.19,
    height: 3.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.71,112.2a2.29,2.29,0,1,0-2.29-2.29A2.29,2.29,0,0,0,417.71,112.2Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.71,
    cy: 123.8,
    r: 2.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.08,
    y: 366,
    width: 21.57,
    height: 21.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.52 375.13 48.03 375.13 48.03 369.63 45.7 369.63 45.7 375.13 40.2 375.13 40.2 377.46 45.7 377.46 45.7 382.95 48.03 382.95 48.03 377.46 53.52 377.46 53.52 375.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: 366,
    width: 21.57,
    height: 21.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.64,
    y: 375.13,
    width: 11.49,
    height: 2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.08,
    y: 387.53,
    width: 21.57,
    height: 21.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.75 392.28 46.86 396.17 42.98 392.28 41.33 393.93 45.22 397.82 41.33 401.7 42.98 403.35 46.86 399.46 50.75 403.35 52.4 401.7 48.51 397.82 52.4 393.93 50.75 392.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: 387.53,
    width: 21.57,
    height: 21.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.64,
    y: 396.65,
    width: 11.49,
    height: 2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.38,
    cy: 393.38,
    r: 1.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.38,400.7a1.45,1.45,0,1,0,1.45,1.45A1.45,1.45,0,0,0,68.38,400.7Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.48,109.2a.24.24,0,0,0-.2.23l0,1.48a.49.49,0,0,1-.56.56h-1.95a.49.49,0,0,1-.56-.56l.07-1.51a.26.26,0,0,0-.2-.24c-3.76-.46-5.93-2.73-5.93-5.9v-1.41a.5.5,0,0,1,.56-.56h3.42c.37,0,.57.16.57.42v.47a3,3,0,0,0,3.32,3.13c2.11,0,3-1.29,3-2.61,0-2.34-4.28-2.7-7.45-4.74-2-1.26-3.46-2.87-3.46-5.67,0-3.46,2.15-5.9,5.94-6.46a.25.25,0,0,0,.19-.23l-.06-1.78a.49.49,0,0,1,.56-.56h1.88a.5.5,0,0,1,.56.56l0,1.74a.23.23,0,0,0,.19.23c4,.43,6.2,2.84,6.2,6.23v1.09a.51.51,0,0,1-.56.56h-3.46c-.36,0-.56-.13-.56-.33V93a3.09,3.09,0,0,0-3.3-3.33c-1.84,0-3,1-3,2.44,0,2.14,3,2.47,6.09,3.83,3.4,1.51,4.88,3.62,4.88,6.52C303.71,106.1,301.5,108.67,297.48,109.2Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.66,
    cy: 97.54,
    r: 18.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33,74.35a.17.17,0,0,0-.14.16l0,1a.33.33,0,0,1-.38.37h-1.3a.33.33,0,0,1-.38-.37l.05-1a.17.17,0,0,0-.13-.15c-2.52-.31-4-1.83-4-4v-.95a.35.35,0,0,1,.38-.38h2.29c.25,0,.38.11.38.29v.31a2,2,0,0,0,2.23,2.1,1.76,1.76,0,0,0,2-1.75c0-1.56-2.87-1.81-5-3.18A4.16,4.16,0,0,1,141.08,63a4.21,4.21,0,0,1,4-4.33.17.17,0,0,0,.14-.15l-.05-1.19a.33.33,0,0,1,.38-.38h1.26a.34.34,0,0,1,.37.38l0,1.17a.16.16,0,0,0,.13.15c2.65.29,4.15,1.9,4.15,4.17v.73A.34.34,0,0,1,151,64h-2.31c-.25,0-.38-.08-.38-.22v-.22a2.06,2.06,0,0,0-2.2-2.23c-1.24,0-2,.64-2,1.64,0,1.43,2,1.65,4.08,2.56,2.28,1,3.27,2.43,3.27,4.37C151.5,72.28,150,74,147.33,74.35Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.1,
    cy: 66.55,
    r: 12.55,
    transform: "translate(-4.26 122.8) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.19,200.07a.15.15,0,0,0-.13.15l0,1c0,.27-.13.38-.37.38H48.4c-.24,0-.37-.11-.37-.38l0-1a.17.17,0,0,0-.13-.16c-2.52-.3-4-1.83-4-3.95v-1a.33.33,0,0,1,.37-.37h2.3c.24,0,.37.11.37.29v.31a2,2,0,0,0,2.23,2.09,1.76,1.76,0,0,0,2-1.74c0-1.57-2.87-1.81-5-3.18a4.31,4.31,0,0,1,1.66-8.12.16.16,0,0,0,.13-.16l0-1.19a.32.32,0,0,1,.37-.37h1.26a.34.34,0,0,1,.38.37l0,1.17a.18.18,0,0,0,.14.16c2.64.28,4.15,1.89,4.15,4.17v.73a.34.34,0,0,1-.38.37H51.58c-.24,0-.37-.09-.37-.22v-.22A2.07,2.07,0,0,0,49,187c-1.24,0-2,.64-2,1.63,0,1.44,2,1.66,4.09,2.56,2.27,1,3.26,2.43,3.26,4.37C54.36,198,52.88,199.71,50.19,200.07Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.97,
    cy: 192.26,
    r: 12.55,
    transform: "translate(-121.61 90.94) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.22,371.81a.15.15,0,0,0-.13.15l0,1c0,.27-.13.38-.37.38h-1.31c-.24,0-.37-.11-.37-.38l0-1a.17.17,0,0,0-.13-.16c-2.52-.31-4-1.83-4-3.95v-.95a.33.33,0,0,1,.37-.37h2.3c.24,0,.37.11.37.29v.3a2,2,0,0,0,2.23,2.1,1.76,1.76,0,0,0,2-1.74c0-1.57-2.87-1.81-5-3.18a4.31,4.31,0,0,1,1.66-8.12.17.17,0,0,0,.13-.16l0-1.19a.32.32,0,0,1,.37-.37h1.26a.34.34,0,0,1,.38.37l0,1.17a.16.16,0,0,0,.14.15c2.64.29,4.15,1.9,4.15,4.18V361a.34.34,0,0,1-.38.38h-2.32c-.24,0-.37-.09-.37-.22V361a2.06,2.06,0,0,0-2.21-2.23c-1.24,0-2,.64-2,1.63,0,1.44,2,1.66,4.09,2.56,2.27,1,3.26,2.43,3.26,4.37C467.39,369.73,465.91,371.45,463.22,371.81Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462,
    cy: 364,
    r: 12.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.85,448.51c0,3.34-76.58,6.05-171,6.05s-171-2.71-171-6.05,76.58-6,171.05-6S421.85,445.18,421.85,448.51Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,394.21s8.32,35.76,4.7,41.63c-4.74,7.69-55.15,12.32-55.15,12.32H299.21s13.93-3.91,9.74-15.11c-3.24-8.66-18.79-38.84-18.79-38.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.06,394.21s8.88,36.06,4.7,41.63-52.71,9.84-52.71,9.84H299.73s9.39-3.79,6.78-12.63-18.78-38.84-18.78-38.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.73,394.21H236.06s5.26,21.36,5.77,33.74h62.75C299.5,416.05,287.73,394.21,287.73,394.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.05,
    y: 445.86,
    width: 111.15,
    height: 2.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.99,
    y: 146.19,
    width: 335.38,
    height: 251.53,
    rx: 8.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.09,
    y: 146.19,
    width: 335.38,
    height: 251.53,
    rx: 8.48,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.09,358.63H425.47a0,0,0,0,1,0,0v30.61a8.48,8.48,0,0,1-8.48,8.48H98.57a8.48,8.48,0,0,1-8.48-8.48V358.63A0,0,0,0,1,90.09,358.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.96,
    y: 161.84,
    width: 301.64,
    height: 177.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.08,
    y: 264.15,
    width: 256.06,
    height: 11.24,
    style: {
      fill: "#007CB5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.08,
    y: 285.39,
    width: 256.06,
    height: 11.24,
    style: {
      fill: "#007CB5"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.06,
    y1: 197.11,
    x2: 167.11,
    y2: 197.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.06,
    y1: 203.73,
    x2: 167.11,
    y2: 203.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.13,
    y1: 203.73,
    x2: 313.18,
    y2: 203.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.13,
    y1: 210.32,
    x2: 313.18,
    y2: 210.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.13,
    y1: 216.91,
    x2: 313.18,
    y2: 216.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.06,
    y1: 210.36,
    x2: 167.11,
    y2: 210.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.06,
    y1: 321.55,
    x2: 167.11,
    y2: 321.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.06,
    y1: 327.69,
    x2: 167.11,
    y2: 327.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.06,
    y1: 216.98,
    x2: 167.11,
    y2: 216.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.06,
    y: 223.61,
    width: 107.98,
    height: 11.92,
    style: {
      fill: "#007CB5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.79,
    y: 211.68,
    width: 56.97,
    height: 5.96,
    style: {
      fill: "#007CB5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.79,
    y: 196.45,
    width: 56.97,
    height: 21.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.79,
    y: 202.41,
    width: 56.97,
    height: 9.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.46,
    y1: 196.63,
    x2: 329.46,
    y2: 217.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.08,
    y: 243.54,
    width: 256.06,
    height: 71.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.08,
    y: 243.54,
    width: 256.06,
    height: 11.24,
    style: {
      fill: "#007CB5",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.85,
    y1: 243.81,
    x2: 302.85,
    y2: 315.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.68,
    y1: 243.81,
    x2: 330.68,
    y2: 315.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.62,
    y: 319.63,
    width: 27.97,
    height: 16.63,
    style: {
      fill: "#007CB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.18,325.93v1.28c0,1.57-.75,2.42-2.3,2.42h-.72v3.69h-1.54v-9.81h2.26C312.43,323.51,313.18,324.36,313.18,325.93Zm-3-1v3.32h.72c.5,0,.76-.22.76-.92v-1.48c0-.7-.26-.92-.76-.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,333.32H317.7l-.26-1.78h-1.89l-.27,1.78h-1.41l1.56-9.81h2.26Zm-3.52-3.11h1.49l-.74-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.29,330.07l-2-6.56H321l1.18,4.47,1.17-4.47h1.48l-1.95,6.56v3.25h-1.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.62,177.87h2.31v14.7h-2.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.09,181.92v10.65H127v-14.7h2.9l2.37,8.8v-8.8h2.06v14.7H132Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.9,189.86l1.77-12h2.12l-2.27,14.7h-3.44l-2.27-14.7h2.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.07,181.4c0-2.36,1.24-3.7,3.51-3.7s3.5,1.34,3.5,3.7V189c0,2.35-1.23,3.69-3.5,3.69s-3.51-1.34-3.51-3.69Zm2.31,7.79c0,1,.46,1.44,1.2,1.44s1.19-.4,1.19-1.44v-7.94c0-1.05-.46-1.45-1.19-1.45s-1.2.4-1.2,1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,177.87h2.31v14.7H154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1,187.09V189c0,2.35-1.17,3.69-3.44,3.69s-3.44-1.34-3.44-3.69V181.4c0-2.36,1.17-3.7,3.44-3.7s3.44,1.34,3.44,3.7v1.42h-2.18v-1.57c0-1.05-.46-1.45-1.2-1.45s-1.19.4-1.19,1.45v7.94c0,1,.46,1.42,1.19,1.42s1.2-.38,1.2-1.42v-2.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,184.06h3.17v2.1h-3.17v4.31h4v2.1h-6.3v-14.7h6.3V180h-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.96,
    y: 161.84,
    width: 301.64,
    height: 8.21,
    style: {
      fill: "#007CB5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,378.18a6.19,6.19,0,1,0-6.18,6.18A6.19,6.19,0,0,0,264,378.18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.47,462.81c0,4-17.78,7.19-39.72,7.19S355,466.78,355,462.81s17.79-7.19,39.72-7.19S434.47,458.84,434.47,462.81Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.2,278.5s-4.28,1.6-5.61,7.62-4.15,24.2-5.62,32.76-9.36,36.36-9.36,36.36l4.15,2.81s10.16-14.84,13-21.79,5.61-11.77,6-17.12-.26-34.76-.26-37S371.41,278.23,370.2,278.5Z",
    style: {
      fill: "#007CB5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.08,453.07s-10.56,6.82-11.77,9.22,1.07,3.08,7,2.28,10-3.88,12.83-5.49,4.15-1.73,3.21-5.34S374.08,453.07,374.08,453.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.39,454.14s11.64,7.88,11,9.62-4.15,2.54-10.3.54-7.49-3.61-10-5.75-1.6-4.81-1.6-6.69S415.39,454.14,415.39,454.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.6,332s-2.41,21.12-2.68,38,7.49,81.11,7.49,81.78v2a18.48,18.48,0,0,0,6.29,1.6,52.94,52.94,0,0,0,6.81-.27s0-11.9.27-21.12,1.74-51.3,1.74-51.3l.4-18.18,2.67,1.74,12.57,89.13,11.23-1.2s1.34-59.32,1.07-75.63S413,333.45,413,333.45Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.59,272.22s-17.78,5.48-19.39,6.28-2.67,5.08-2.67,10.43,2,31.82,1.74,35-1.87,7.22-.54,9.49,19,3.74,28.48,3.34,14.84.54,16.18-2.14,2.14-35.69,3.47-43.32,2.28-11.63-.4-13.77-16.84-4.68-20.32-5.48Z",
    style: {
      fill: "#007CB5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,268.85s-2.95,1-3.93,3.21-3.92,13.21-2.85,13.74,9.37-3.48,10.62-3.21,6.33,6.87,7.85,6,5.09-10.26,3.75-15.08S390.33,267.6,389,268.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.38,265.82s-.09,4.9-.09,7.4,2.15,11.42,4,11.07,9.64-9.1,10.89-11.43,1.51-7.13,1.51-7.13-5.53,3.92-9.72,2.67A36.52,36.52,0,0,1,387.38,265.82Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,268.4a36.52,36.52,0,0,1-6.61-2.58s0,1.93-.06,4c.61,1.31,1.19,2.41,1.6,3.19a5.18,5.18,0,0,0,6.62,2.77,21.42,21.42,0,0,0,7.56-5.59,30.42,30.42,0,0,0,.61-4.44S398.18,269.65,394,268.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.28,251.46s-.5-3.56-2.18-2.11-1.38,5.09-.58,6.84,1.67,1.53,1.89,1.45S385.28,251.46,385.28,251.46Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.56,254.88c.22-.36,2.91-9.38,3.06-14.26s-6.91-9.45-11.93-10.4-12.44.29-14,3.13-1.75,14-1.75,15.86,1.46,2.18,1.82,1.74,1.46-11.42,2.11-12.22,12.29-.43,14.11.07,2.84,2.41,2.48,5.17.07,2.62.8,4.22.72,2.18.72,4.36S407,257.35,408.56,254.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.89,238.37a121.69,121.69,0,0,0-2.62,16.22c-.37,6.47,3.2,13.16,4.65,15.93s4.08,3.71,6.62,2.76a22.36,22.36,0,0,0,8.8-7c2.69-3.49,4.08-11.86,4.08-11.86s-1.1.58-1.17-.36.66-4.22-.07-6.33-2.33-2.62-1.38-4.66a13.61,13.61,0,0,0,1.31-3.63c0-.37-3.64-2.55-10.26-3.13S387.25,236.55,386.89,238.37Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.61,244.33s1.95-1.69,4.66.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.45,245.1s4.66-1.87,6.53,1.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.69,255.46s1.45-3.27,3.56-3.42,1.82,4-.14,6.7-4.8,3.78-4.88,1.81",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.43,249.57s-2.4,6.91-1.89,7.86,2.47,2,4.87.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.38,261.57a6.58,6.58,0,0,0,6.25-1.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,249.82c0,.79-.28,1.42-.62,1.42s-.62-.63-.62-1.42.28-1.41.62-1.41S391,249,391,249.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.51,
    cy: 250.77,
    rx: 0.62,
    ry: 1.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.5,249.39a4.18,4.18,0,1,1-4.18-4.18A4.18,4.18,0,0,1,393.5,249.39Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.35,250.29a4.4,4.4,0,1,1-4.4-4.41A4.4,4.4,0,0,1,404.35,250.29Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.5,248.62a1.67,1.67,0,0,1,2,.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.27,
    y1: 250.73,
    x2: 409.51,
    y2: 252.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.68,
    y1: 352.17,
    x2: 356.3,
    y2: 354.44,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5,369.29s.79,4.62,1.33,4.87.73-2.25.55-3.83l-.18-1.58s.85,4.13,1.7,4.5.37-1.46.12-2.38l-.24-.91s2.13,2.25,2.31,1.7-1.28-3.28-1.34-3.46A22.49,22.49,0,0,1,349,365c-.06-.85-1.27-4.26-2.49-2.13S345.5,369.29,345.5,369.29Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.61,355.24s-4,6.42-5.08,8.56-1.87,10.16-.93,10.7,1.19-1.42,1.41-2.77a21.07,21.07,0,0,1,1.7-4.63s-.57,5.12.23,5,1.47-4.81,2-6,3.75-2.94,4.82-8Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,367.1s0-.68.49-3.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.93,277.3a20,20,0,0,1,6.68,8.95c2.54,6.29,11.23,33.7,11.5,34.23s0,5.88-4.28,7.62-6.28-2-8.82-6.28-8.42-23.27-8.42-23.27",
    style: {
      fill: "#007CB5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.89,312.73l20.76-10.2,3.61,4.15S436,325.29,432.64,327.43s-7.49,1.61-9.09-2",
    style: {
      fill: "#007CB5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 445.38,
    y1: 304,
    x2: 449.25,
    y2: 308.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.65,302.53s4.55-7.08,5.88-7.62,5.08-1.33,7.22-2.94,3.34-1.2,2.14.54-2.54,2-3.74,2.54a9.48,9.48,0,0,0-1.74.93s3.34.14,5.48.27a15.15,15.15,0,0,0,3.88-.27s5.48-2.4,4.14.54-1.2,4.81-6.55,6.41a38.67,38.67,0,0,1-10.69,1.48l-2.41,2.27Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.64,300.93a5.89,5.89,0,0,0,3.61-3.74c.94-2.95.4-3.08-.8-2a14.29,14.29,0,0,0-2.81,4.15C468,300.66,468.64,300.93,468.64,300.93Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.44,301.06s1.6,1.07,2.81-2.14,1.06-5.75,0-5.21-1.34.67-2.68,3.48-2.54,4-1.74,4.27A1.9,1.9,0,0,0,467.44,301.06Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.06,302.27s2-3.35,4.28-3.35a76.94,76.94,0,0,1,8.29,1.07s4.41-6.41,5.35-5.48-1.47,5.35-2.54,6.55-1.21,1.34-2.14,1.61",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.92,
    y1: 364.47,
    x2: 382.77,
    y2: 361.53,
    style: {
      fill: "none",
      stroke: "#7d7d7d",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceBro);
export default __webpack_public_path__ + "static/media/Invoice-bro.28ac8ef6f23314c4acd33d33a9ad9d2a.svg";
export { ForwardRef as ReactComponent };